export default {
  colors: {
    primary: 'rose',
    secondary: 'blue',
    success: 'green',
    info: 'blue',
    warning: 'yellow',
    error: 'red',
    neutral: 'neutral'
  },
  container: {
    base: 'w-full max-w-(--ui-container) mx-auto px-4 sm:px-6 lg:px-8'
  },
  main: {
    base: 'min-h-[calc(100vh-var(--ui-header-height))] mt-0 lg:mt-12 mb-24'
  },
  slideover: {
    slots: {
      overlay: 'bg-black/50',
    }
  },
  header: {
    slots: {
      root: 'bg-default border-0',
    }
  },
  footer: {
    slots: {
      root: 'bg-elevated border-0',
    }
  },
  navigationMenu: {
    variants: {
      active: {
        false: {
          link: 'text-default',
          linkLeadingIcon: 'text-primary'
        }
      }
    }
  },
  page: {
    slots: {
      left: 'lg:col-span-3',
      center: 'lg:col-span-7',
      right: 'lg:col-span-3'
    }
  }
}